import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types/database'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    '[GoGrov] Supabase env vars not set. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY then rebuild.'
  )
}

// Using the Database generic with a hand-written type can cause Supabase's
// internal generics to resolve update/upsert params as `never`. We use an
// untyped client and cast results explicitly at each query site instead.
// When Supabase is unpaused, replace with the generated type from
// `supabase gen types typescript`.
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder_key_set_vite_supabase_anon_key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      storageKey: 'gogrov_auth',
    },
  }
)

// Re-export the Database type so it's still importable from this module
export type { Database }
